/**
 * Chat tab gate.
 *
 * The Chat tab (one inbox per person: receipt texts today, website and
 * sales-desk chats next) is new as of 2026-11-01 and is on for the Testing
 * Store ONLY while Phillip checks it. Per-STORE allowlist like
 * deliveriesAccess.js: nothing in dashboardTabRestrictions can turn it on
 * for a live store. A code commit is the only way to widen it.
 */

const CHAT_ENABLED_STORE_IDS = new Set([
  '1e31fec9-882d-44b4-b870-1899f759764b', // Testing Store
]);

/**
 * @param {string | null | undefined} storeId
 * @returns {boolean}
 */
export function isChatEnabledForStore(storeId) {
  if (!storeId) return false;
  return CHAT_ENABLED_STORE_IDS.has(storeId);
}
